const mapStateToThis = ({ manageInventory, dictionary, session, config }) => {
  const { userSelection, packDetails, packDetailsLoadingStatus: isLoading } = manageInventory;
  const { locale } = session;
  const { usesPortionedPacks } = config;
  const terms = dictionary.terms[locale];

  return {
    userSelection,
    packDetails,
    isLoading,
    terms,
    usesPortionedPacks,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state')
class PackDetailsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default PackDetailsController;



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/pack-details/pack-details.controller.js